// Этап 6, раздел 1 «Логин» (docs/PLAN.md) — единственный экран, доступный без токена.
import { type FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ApiError, login } from "../api/client";
import { useAuthStore } from "../store/authStore";

export function LoginScreen() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const setToken = useAuthStore((state) => state.setToken);
  const navigate = useNavigate();

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const { access_token } = await login(username, password);
      setToken(access_token);
      navigate("/", { replace: true });
    } catch (err) {
      // 429 (rate limit, app/api/routes/admin/auth.py) отдельно от 401 — та же ApiError, разница
      // только в тексте, backend уже отдаёт человекочитаемый detail в обоих случаях.
      setError(err instanceof ApiError ? err.message : "Не удалось войти, попробуйте ещё раз");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="screen login-screen">
      <div className="card login-card">
        <h1>avappbot — админка</h1>
        <form onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="username">Логин</label>
            <input
              id="username"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label htmlFor="password">Пароль</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="error-text">{error}</div>}
          <button type="submit" className="primary" disabled={submitting}>
            {submitting ? "Входим…" : "Войти"}
          </button>
        </form>
      </div>
    </div>
  );
}
